export class IdNameModel {
    id : Number;
    name: string;
    code : number;
    public constructor(init?: Partial<IdNameModel>) {
      Object.assign(this, init);
  }
}
